import React from 'react';
import { Line } from 'rc-progress';
import './SyncProgressPanel.css';

// Card com o botão de "sincronizar tudo" e a barra de progresso da
// sincronização em lote.
const SyncProgressPanel = ({
  label,
  totalCount,
  syncedCount,
  failedCount,
  percent,
  syncing,
  onSyncAll,
  disabled = false,
}) => {
  return (
    <div className="sync-progress-panel">
      <div className="sync-progress-panel__summary">
        <span className="sync-progress-panel__count">{totalCount}</span>
        <span className="sync-progress-panel__count-label">produtos no estoque</span>
      </div>

      <button
        type="button"
        className="sync-progress-panel__button"
        onClick={onSyncAll}
        disabled={syncing || totalCount === 0 || disabled}
      >
        {syncing ? 'Sincronizando...' : `Sincronizar ${label}`}
      </button>

      <div className="sync-progress-panel__progress">
        <div className="sync-progress-panel__progress-header">
          <span>
            {syncedCount} de {totalCount} sincronizados
          </span>
          <span>{Math.round(percent)}%</span>
        </div>
        <Line
          percent={percent}
          strokeWidth={3}
          strokeColor="#7c3aed"
          trailWidth={3}
          trailColor="#e5e7eb"
          className="sync-progress-panel__bar"
        />
        {failedCount > 0 && (
          <p className="sync-progress-panel__failed">{failedCount} produto(s) falharam ao sincronizar.</p>
        )}
      </div>
    </div>
  );
};

export default SyncProgressPanel;
